import React, { Fragment, ReactElement, useEffect } from 'react';

import {
  ButtonPattern,
  Container,
  Grid,
  GridItem,
  Notification,
  Paragraph,
  Text,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { useLocation } from '@interstellar/react-app-routing';
import StyledBox from 'components/style/styledBox/StyledBox';
import { Button } from 'components/tagging';

import { RegistrationInProgressContent } from './RegistrationInProgressContent';
import PageHeading from '../../components/pageHeading/PageHeading';
import { JOURNEY_STEPS } from '../../constants/analytics.constants';
import * as Analytics from '../../utils/analytics';

function RegistrationInProgress(): ReactElement {
  const { registrationInProgressContent } =
    useContent<RegistrationInProgressContent>();
  const { state } = useLocation();
  useEffect(() => {
    Analytics.setPageLoadEvent(
      JOURNEY_STEPS.ONLINE_REGISTRATION.REGISTRATION_IN_PROGRESS,
    );
  }, []);
  return (
    <Container padding="none">
      {registrationInProgressContent &&
        registrationInProgressContent.map(
          ({
            serviceName,
            header,
            infoNotification,
            content1,
            content2,
            backToWebsiteButton,
            backToWebsiteLink,
          }) => (
            <Fragment key="registration-in-progress-content">
              <PageHeading serviceName={serviceName} header={header} />
              <Grid alignX="left" alignY="top">
                <GridItem lg={8}>
                  <StyledBox>
                    <Notification heading={infoNotification}>
                      <Paragraph>
                        <Text>{content1}</Text>
                      </Paragraph>
                      <Paragraph>
                        <Text>{content2}</Text> <Text>{state?.PegaCaseId}</Text>
                      </Paragraph>
                    </Notification>
                    <ButtonPattern marginBottom="none">
                      <Button
                        href={backToWebsiteLink}
                        taggingLabel={backToWebsiteButton}
                      >
                        {backToWebsiteButton}
                      </Button>
                    </ButtonPattern>
                  </StyledBox>
                </GridItem>
              </Grid>
            </Fragment>
          ),
        )}
    </Container>
  );
}

export default RegistrationInProgress;
